import { sample } from "effector";
import {
	$formFields,
	$formValidationErrors,
	askQuestionFx,
	handleFormSubmit,
	updateFormField,
	updateFormPhoneField,
	validateFormFx,
} from "./private";
import { showErrorToast, showSuccessToast } from "@models/toast";

$formFields.on(updateFormField, (form, { event, field }) => {
	return {
		...form,
		[field]: event.target.value,
	};
});

$formFields.on(updateFormPhoneField, (form, value) => {
	return {
		...form,
		phone: value,
	};
});

$formFields.reset(askQuestionFx.done);

$formValidationErrors.on(updateFormField, (errors, { field }) => {
	return {
		...errors,
		[field]: "",
	};
});

$formValidationErrors.on(updateFormPhoneField, (errors) => {
	return {
		...errors,
		phone: "",
	};
});

sample({
	clock: handleFormSubmit,
	target: validateFormFx,
});

sample({
	clock: validateFormFx.failData,
	target: $formValidationErrors,
});

sample({
	clock: validateFormFx.done,
	source: $formFields,
	target: askQuestionFx,
});

sample({
	clock: askQuestionFx.done,
	target: showSuccessToast,
	fn: () => {
		return "Ваш вопрос успешно отправлен";
	},
});

sample({
	clock: askQuestionFx.failData,
	target: showErrorToast,
	fn: (error) => {
		return `Не удалось отправить вопрос. ${error?.message}`;
	},
});
